export const translation = {
  generic: {
    ok: 'OK',
    close: 'Close',
    goHome: 'Back to Homepage',
    error: 'Oops! Something went wrong, we are working on it, please try again later',
    selectAnOption: 'Select an Option',
    continueShopping: 'Continue Shopping',
    cancel: 'Cancel',
    select: 'Select',
    confirm: 'Confirm',
    submit: 'Submit',
    noContent: 'No Content',
    search: 'Search',
  },
  siteContext: {
    language: {
      label: 'Language',
    },
    currency: {
      label: 'Currency',
    },
  },
  category: {
    search: {
      title: 'Result for: {{word}}',
      qtyLabel: '{{start}} - {{end}} of {{total}}',
    },
    noContent: 'Oops! We didn’t find any products related to your search!',
  },
  facets: {
    noContent: 'No facets available.',
  },
  deliveryCost: {
    title: 'Delivery Cost Estimate',
    submit: 'Submit',
    input: {
      placeholder: '00000-000',
    },
    content: {
      total: 'Total',
    },
  },
  productCard: {
    actions: {
      openDetails: 'View Details',
    },
  },
};

export const common = {
  common: {
    ok: 'OK',
    cancel: 'Cancel',
    delete: 'Delete',
    remove: 'Remove',
    edit: 'Edit',
    restore: 'Restore',
    back: 'Back',
    submit: 'Submit',
    continue: 'Continue',
    save: 'Save',
    done: 'Done',
    home: 'Homepage',
    noData: 'No data.',
    confirm: 'Confirm',
    more: 'more',
    close: 'Close',
    loading: 'Loading',
    menu: 'Menu',
    reset: 'Reset',
    search: 'Search',
    add: 'Add',
    breadcrumbs: 'breadcrumbs',
    selectFile: 'Select file',
    clear: 'Clear',
    loaded: 'Loaded',
    results: 'Results',
    of: 'of',
    required: 'required',
    toggleAll: 'Toggle All',
  },
  pageMetaResolver: {
    category: {
      title: '{{count}} result for {{query}}',
      title_other: '{{count}} results for {{query}}',
    },
    checkout: {
      title: 'Checkout',
    },
    search: {
      title: '{{count}} result for "{{query}}"',
      title_other: '{{count}} results for "{{query}}"',
      findProductTitle: '{{count}} result for coupon "{{coupon}}"',
      findProductTitle_other: '{{count}} results for coupon "{{coupon}}"',
      default_title: 'All products',
    },
    product: {
      description: '{{description}}',
      heading: '{{heading}}',
      title: '{{title}} | Marathon Electric LLC',
    },
  },
  spinner: {
    loading: 'Loading...',
  },
  navigation: {
    categoryNavLabel: 'Category Menu',
    footerNavLabel: 'Footer Links',
    navigateTo: 'Navigate to {{nav}}',
    scrollToTop: 'Back to top of the page',
  },
  searchBox: {
    placeholder: 'Search by product, category or code',
    productSearch: 'Find a product',
    ariaLabelInput: 'Search here...',
    ariaLabelSuggestions: 'typing suggestions',
    ariaLabelProducts: 'product results',
    initialDescription:
      'When automatic results are available, use up and down arrows to review and enter to select. Touch device users, explore by touch or swipe gestures.',
    suggestions: 'Suggested keywords',
    suggestionsResult: '{{ count }} suggestion and ',
    suggestionsResult_other: '{{ count }} suggestions and ',
    products: 'Recommended products',
    productsResult: '{{ count }} product is available.',
    productsResult_other: '{{ count }} products are available.',
    resetLabel: 'Reset Search',
    help: {
      insufficientChars: 'Please enter more characters',
      noMatch: 'We could not find any results',
      exactMatch: '{{ term }}',
      empty: 'Ask us anything',
    },
  },
  sorting: {
    date: 'Date',
    orderNumber: 'Order Number',
    rma: 'Return Number',
    replenishmentNumber: 'Replenishment Number',
    nextOrderDate: 'Next Order Date',
    pageViewUpdated: 'Page view updated with the selected options.',
  },
  httpHandlers: {
    badRequest: {
      bad_credentials: '{{ errorMessage }}. Please log in again.',
      user_is_disabled: '{{ errorMessage }}. Please contact administration.',
      password: {
        expired: 'Your password has expired. Click the "Forgot your password?" link and enter a new password.',
      },
    },
    badGateway: 'There was a server error. Please try again later.',
    badRequestPleaseLoginAgain: '{{ errorMessage }}. Please log in again.',
    badRequestOldPasswordIncorrect: 'Incorrect old password.',
    badRequestGuestDuplicateEmail:
      '{{ errorMessage }} email already exists. Please checkout with a different email to register using a guest account.',
    conflict: 'Already exists.',
    forbidden:
      'You are not authorized to perform this action. Contact your administrator if you believe this is an error.',
    gatewayTimeout: 'The server did not respond, please try again later.',
    internalServerError: 'An Internal Server Error occurred. Please try again later.',
    sessionExpired: 'Your session has expired. Please log in again.',
    unknownError: 'An unknown error occurred',
    unauthorized: {
      common: 'An unknown authorization error occurred',
      invalid_client: 'Invalid client credentials',
    },
    validationErrors: {
      missing: {
        card_cardType: 'The selected credit card is not supported. Please choose another one.',
        card_accountNumber: 'The credit card number entered is not valid.',
        card_cvNumber: 'The security code entered is not valid.',
        card_expirationMonth: 'The credit card expiration date entered is not valid.',
        card_expirationYear: 'The credit card expiration date entered is not valid.',
        billTo_firstName: 'The first name entered is not valid.',
        billTo_lastName: 'The last name entered is not valid.',
        billTo_street1: 'The address entered is not valid.',
        billTo_street2: 'The address entered is not valid.',
        billTo_city: 'The city entered is not valid for this credit card.',
        billTo_state: 'The state/province entered is not valid for this credit card.',
        billTo_country: 'The country/region entered is not valid for this credit card.',
        billTo_postalCode: 'The postal code is not valid for this credit card.',
        country: {
          isocode: 'Country/region missing',
        },
      },
      invalid: {
        card_expirationMonth: 'The credit card expiration date entered is not valid.',
        firstName: 'The entered name is not valid.',
        lastName: 'The entered last name is not valid.',
        password: 'The entered password is not valid.',
        uid: 'UID is not valid.',
        code: 'Code is not valid.',
        email: 'Email is not valid.',
        'address Id': 'Invalid address for this Cost Center.',
      },
    },
    cartNotFound: 'Cart not found.',
    invalidCodeProvided: 'Provided code is invalid.',
    voucherExceeded: 'This coupon exceeded the number of times it can be used',
    unknownIdentifier: 'Item not found.',
    otherCartErrors: 'Cart errors occurred.',
  },
  miniCart: {
    item: '{{count}} item currently in your cart',
    item_other: '{{count}} items currently in your cart',
    total: '{{total}}',
    count: '{{count}}',
  },
  skipLink: {
    skipTo: 'Skip to',
    labels: {
      header: 'Header',
      main: 'Main Content',
      footer: 'Footer',
      productFacets: 'Product Facets',
      productList: 'Product List',
    },
  },
  carousel: {
    previousSlide: 'Previous slide',
    nextSlide: 'Next slide',
    slideNumber: 'Slide {{currentSlideNumber}}',
    carouselForProduct: 'Carousel, Images for {{product}}',
  },
  formErrors: {
    minlength: 'Minimum number of characters is {{requiredLength}}',
    maxlength: 'Maximum number of characters is {{requiredLength}}',
    mask: 'Invalid Value',
    noLeadingBlankSpacesMinLength:
      'Please provide at least {{requiredLength}} non-blank characters to perform a search.',
    globalMessage: 'The form you are trying to submit contains errors.',
    required: 'This field is required',
    email: 'This is not a valid email format',
    cxInvalidEmail: 'This is not a valid email format',
    cxInvalidPassword: 'This is not a valid password format',
    cxPasswordsMustMatch: 'The password and the password confirmation do not match',
    cxEmailsMustMatch: 'Email fields must match',
    cxStarRatingEmpty: 'Rating field is required',
    cxNoSelectedItemToCancel: 'Select at least one item',
    cxNegativeAmount: 'Amount must be zero or greater',
    cxContainsSpecialCharacters: 'Field cannot contain special characters',
    noBlankSpaces: 'Please provide non-blank characters.',
    invalidPassword:
      'The password must have 8 to 16 characters, including at least 1 uppercase letter, 1 lowercase letter, 1 number and 1 special character.',
    date: {
      required: 'This field is required',
      min: 'Date cannot be before {{min}}',
      max: 'Date cannot be after {{max}}',
      pattern: 'Use date format yyyy-mm-dd',
      invalid: 'Use a valid date',
    },
    file: {
      required: 'File is required',
      empty: 'File must not be empty',
      invalidExtension: 'File extension is not valid',
      tooLarge: 'File size must not exceed {{maxSize}} MB',
      tooManyEntries: 'The number of items exceeds {{maxEntries}}',
      notParsable: 'File is not parsable',
      fileNotAllowed: 'This file type is not allowed',
    },
    accountNumber: 'Account number is not verified - Please click on the Validate button.',
    accountNumberNotValid: 'Account Number is not valid.',
    linkedAccount: 'User already has permission for this account at Marathon.com.',
    invalidAccountNumber: `The entered account is not registered or is not valid, please contact your sales representative or customer service team for further assistance`,
  },
  errorHandlers: {
    scriptFailedToLoad: 'Failed to load the script.',
    refreshThePage: 'Please refresh the page.',
  },
  assistiveMessage: {
    actionCancelled: 'Action cancelled, nothing was changed',
  },
  passwordVisibility: {
    showPassword: 'Show password',
    hidePassword: 'Hide password',
  },
  generalErrors: {
    pageFailure: 'The page could not be loaded. Please try again later.',
  },
  formLegend: {
    required: "The following fields marked with '*' are required.",
  },
  chatMessaging: {
    charactersLeft: 'characters remaining: {{count}}',
    addNewMessage: 'Add New Message',
    send: 'Send',
    uploadFile: 'Upload File',
    informationLabel: '{{author}}. {{text}} on {{date}}',
    messages: 'Messages',
    addMessagePlaceHolder: 'Start typing...',
    characterLimitAlert: 'Character limit reached.',
    a11y: {
      itemListBoxLabel: 'Select the item to which the message should be applied.',
    },
  },
  formSearch: {
    from: 'From',
    to: 'To',
    search: 'Search',
    clearAll: 'Clear All',
    searchBy: 'Search By:',
    selectDateRange: 'Select Date Range',
    selectOption: 'Select an option',
    enterValue: 'Enter value',
    note: 'Note: the search results are limited to the last 12 months.',
    dateRangeOptions: {
      last30Days: 'Last 30 Days',
      last60Days: 'Last 60 Days',
      last90Days: 'Last 90 Days',
      customRange: 'Custom Range',
    },

    invoiceNumber: 'Invoice #',
    poNumber: 'PO #',
    orderNumber: 'Order #',
    catalogNumber: 'Catalog #',
    partNumber: 'Part #',
    customerPartNumber: 'Customer Part #',
    valuesInclude: 'Values that include...',
  },
};
